import { 
  Volunteer, 
  VolunteerFormData
} from '../types/volunteer';
import { appApi } from '../../../store/app.api';
import { appEndpoint } from '../../../store/app.endpoint';
import { CommandRequest } from '../../../libs/auth/utilities/command-request';

export const volunteersApi = appApi.injectEndpoints({
  endpoints: (build) => ({
    getVolunteers: build.query<any, void>({
      query: () => ({
        url: appEndpoint.getVolunteers,
        method: 'get',
      }),
      providesTags: ['Volunteers'],
    }),
    
    getVolunteerById: build.query<any, string>({
      query: (id) => ({
        url: `${appEndpoint.getVolunteers}/${id}`,
        method: 'get',
      }),
      providesTags: (result, error, id) => [{ type: 'Volunteers', id }],
    }),

    addVolunteer: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: appEndpoint.addVolunteer,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Volunteers"] : []),
    }),

    updateVolunteer: build.mutation<any, CommandRequest>({
      query: (data) => ({
        url: `${appEndpoint.updateVolunteer}/${data.id}?_method=put`,
        method: 'post',
        data: data.body
      }),
      invalidatesTags: (result) => (result ? ["Volunteers"] : []),
    }),

    deleteVolunteer: build.mutation<void, string>({
      query: (id) => ({
        url: `${appEndpoint.deleteVolunteer}/${id}`,
        method: 'delete',
      }),
      invalidatesTags: ['Volunteers'],
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetVolunteersQuery,
  useGetVolunteerByIdQuery,
  useAddVolunteerMutation,
  useUpdateVolunteerMutation,
  useDeleteVolunteerMutation,
} = volunteersApi;

